import http from 'plugins/axios';

const DEFAULT_COIN = 'USDT';

export function loadCoinOptions() {
  return http.get({
    url: '/ta/admin/tenant/coin/list',
    data: { type: 'SPOT' },
  }).then((res) => {
    if (res.code !== 0 || !Array.isArray(res.data) || !res.data.length) {
      return [DEFAULT_COIN];
    }
    const coins = res.data.map((c) => String(c).toUpperCase());
    if (!coins.includes(DEFAULT_COIN)) {
      coins.unshift(DEFAULT_COIN);
    }
    return coins;
  }).catch(() => [DEFAULT_COIN]);
}

export { DEFAULT_COIN };
